/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantusergroupid3Inputs */

const en_entity_tenantusergroupid3 = /** @type {(inputs: Entity_Tenantusergroupid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant User Group ID`)
};

const de_entity_tenantusergroupid3 = /** @type {(inputs: Entity_Tenantusergroupid3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-Benutzergruppen-ID`)
};

/**
* | output |
* | --- |
* | "Tenant User Group ID" |
*
* @param {Entity_Tenantusergroupid3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantusergroupid3 = /** @type {((inputs?: Entity_Tenantusergroupid3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantusergroupid3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantusergroupid3(inputs)
	return de_entity_tenantusergroupid3(inputs)
});
export { entity_tenantusergroupid3 as "entity_tenantUserGroupId" }